<template>
    <b-modal
        hide-footer
        size="lg"
        :visible="isModalFileListsShow"
        @change="(val) => $emit('update:is-modal-file-lists-show', val)"
    >
        <template #modal-title>
            Upload Image {{uploadType}}
        </template>
        <div class="w-100 d-flex justify-content-between">
            <b-breadcrumb class="breadcrumb-slash "  style="width: 50%;" v-if="breadcrumbsData.length > 0">
                <template v-for="(bred,index) in breadcrumbsData" >
                    <b-breadcrumb-item v-if="(index+1) == breadcrumbsData.length"  :key="'b-'+index" active>
                        {{  bred.title }}
                    </b-breadcrumb-item>
                    <b-breadcrumb-item v-else  :key="'b-'+index" >
                        <b-link  @click="clickBread(bred,index)">{{  bred.title }}</b-link>
                    </b-breadcrumb-item>
                </template>
            </b-breadcrumb>
            <div>
                <b-button 
                    v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                    variant="outline-success mr-2"
                    @click="newFolder"
                >
                    New Folder
                </b-button>
                <b-button 
                    v-if="(parent > 0) && (uploadType == 'image')"
                    v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                    variant="outline-primary"
                    @click="uploadFiles"
                >
                    Upload File
                </b-button>
                <b-button 
                    v-if="(parent > 0) && (uploadType == 'video')"
                    v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                    variant="outline-primary"
                    @click="uploadFiles"
                >
                    Upload video
                </b-button>
            </div>
        </div>
        <draggable
            v-model="folders"
            tag="ul"
            class="list-group d-flex flex-wrap   list-group-horizontal cursor-move"
            @change="changeOrderFolder"
        >
            <template 
                v-for="(item, index) in folders"
            >
                <b-list-group-item 
                    v-if="!item.types"
                    :key="'folder-'+index"
                    tag="li"
                    class="border-0 text-center p-2"
                    @contextmenu.prevent="$refs.folder.open($event,item)"
                >
                    <div
                        @dblclick="openFolder(item)"
                    >
                        <feather-icon
                            icon="FolderIcon"
                            size="62"
                        />
                        <div class="text-center">
                            <strong>{{ item.title }}</strong>
                        </div>
                    </div>
                </b-list-group-item>
                <b-list-group-item 
                    v-else
                    :key="'file-'+index"
                    tag="li"
                    class="border-0 text-center p-2"
                    @contextmenu.prevent="$refs.files.open($event,item)"
                >
                    <div>
                        <b-img
                            :src="item.fullpath"
                            v-if="item.types == 'i'"
                            style="height: 62px;"
                            thumbnail
                        />
                        <feather-icon
                            icon="FileIcon"
                            size="62"
                            v-else
                        />
                        <div class="text-center">
                            <strong>{{ item.title }}</strong>
                        </div>
                    </div>
                </b-list-group-item>
            </template>
        </draggable>
        <br/>
        <vue-context ref="folder" @open="onOpen">
            <li>
                <b-link
                    v-for="data in menuFolder"
                    :key="data.text"
                    class="d-flex align-items-center"
                    @click="onOptionClick(data,itemData)"
                >
                    <feather-icon
                        :icon="data.icon"
                        size="16"
                    />
                    <span class="ml-75">{{ data.text }}</span>
                </b-link>
            </li>
        </vue-context>
        <vue-context ref="files"  @open="onOpen" >
            <li>
                <b-link
                    v-for="data in menuFiles"
                    :key="data.text"
                    class="d-flex align-items-center"
                    @click="optionFileClicked(data,itemData)"
                >
                    <feather-icon
                        :icon="data.icon"
                        size="16"
                    />
                    <span class="ml-75">{{ data.text }}</span>
                </b-link>
            </li>
        </vue-context>
        <rename-modal :is-modal-rename-show.sync="isModalRenameShow" :itemData.sync="itemData" @refetch-data="getAll" />
        <new-folder-modal :is-modal-new-folder-show.sync="isModalNewFolderShow" :parentData.sync="parent" :countFolder.sync="folders.length" @refetch-data="getAll" />
        <upload-files-modal :is-modal-upload-files-show.sync="isModalUploadFilesShow" :parentData.sync="parent" :countFolder.sync="folders.length" :uploadType.sync="uploadType" @refetch-data="getAll" />
        <files-detail-modal :is-modal-detail-files-show.sync="isModalDetailFilesShow" :itemData.sync="itemData" :parentData.sync="parent" :countFolder.sync="folders.length" @refetch-data="getAll" />
    </b-modal>
</template>

<script>
import {
    BCard,BCardHeader, BRow, BCol, BFormInput, BButton, BTable, BMedia, BAvatar, BLink,BImg,
    BBadge, BDropdown, BDropdownItem, BPagination, BTooltip,VBModal,BFormGroup,BFormCheckbox,
    BListGroup,BListGroupItem,BBreadcrumb, BBreadcrumbItem
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import { ref,onUnmounted } from '@vue/composition-api'
import draggable from 'vuedraggable'
import Prism from 'vue-prism-component'
import 'prismjs'
import 'prismjs/themes/prism-tomorrow.css'
import VueContext from 'vue-context'
import axios from '@axios'
import useFileLists from './useFileLists'
import RenameModal from './RenameModal.vue'
import NewFolderModal from './NewFolderModal.vue'
import UploadFilesModal from './UploadFilesModal.vue'
import FilesDetailModal from './FilesDetailModal.vue'

export default {
    components:{
        BCard, BCardHeader, BRow, BCol, BFormInput, BButton, BTable, BMedia, BAvatar, BLink, BImg,
        BBadge, BDropdown, BDropdownItem, BPagination, BTooltip, VBModal, BFormGroup, BFormCheckbox,
        draggable, Prism, VueContext, BListGroup, BListGroupItem, BBreadcrumb, BBreadcrumbItem,
        RenameModal, NewFolderModal, UploadFilesModal, FilesDetailModal,
    },

    directives:{
        'b-modal': VBModal,
        Ripple
    },

    model: {
        prop: 'isModalFileListsShow',
        event: 'update:is-modal-file-lists-show',
    },

    props: {
        isModalFileListsShow: {
            type: Boolean,
            require: true
        },
        uploadType: {
            type: String
        }
    },

    setup(props, { emit }) {

        const {
            breadcrumbsData,
            newFolder,
            parent,
            changeOrderFolder,
            folders,
            menuFolder,
            menuFiles,
            isModalRenameShow,
            itemData,
            getAll,
            optionClicked,
            isModalNewFolderShow,
            isModalUploadFilesShow,
            openFolder,
            uploadFiles,
            isModalDetailFilesShow,
            clickBread,
            deleteData,
        } = useFileLists(emit)

        return {
            breadcrumbsData,
            newFolder,
            parent,
            changeOrderFolder,
            folders,
            menuFolder,
            menuFiles,
            isModalRenameShow,
            itemData,
            getAll,
            optionClicked,
            isModalNewFolderShow,
            isModalUploadFilesShow,
            openFolder,
            uploadFiles,
            isModalDetailFilesShow,
            clickBread,
            deleteData,
            // filterFolderData,
        }
    },

    methods: {
        async forceFileDownload(item) {
            let res = await axios.get(item.fullpath, { responseType: 'blob' });
            var FILE = window.URL.createObjectURL(new Blob([res.data]));
            var docUrl = document.createElement('a');

            docUrl.href = FILE;
            docUrl.setAttribute('download', item.filename);
            document.body.appendChild(docUrl);
            docUrl.click();
        },

        onOpen(event,data) {
            this.itemData = data;
        },

        optionFileClicked(data,item) {
            if(data.text == 'Delete'){
                this.$bvModal.msgBoxConfirm('Please confirm that you want to delete File Name '+item.name, {
                    title: 'Please Confirm',
                    size: 'sm',
                    okVariant: 'danger',
                    okTitle: 'Yes',
                    cancelTitle: 'No',
                    cancelVariant: 'outline-secondary',
                    hideHeaderClose: false,
                    centered: true,
                })
                .then(value => {
                    if(value === true){
                        this.deleteFilesData(item.id)
                    }
                })
            } else if(data.text == 'Download') {
                this.forceFileDownload(item);
            } else {
                this.optionClicked(data,item);
            }
        },

        onOptionClick(data,item) {
            if(data.text == 'Delete'){
                this.$bvModal.msgBoxConfirm('Please confirm that you want to delete Folder Name '+item.title, {
                    title: 'Please Confirm',
                    size: 'sm',
                    okVariant: 'danger',
                    okTitle: 'Yes',
                    cancelTitle: 'No',
                    cancelVariant: 'outline-secondary',
                    hideHeaderClose: false,
                    centered: true,
                })
                .then(value => {
                    if(value === true){
                        this.deleteData(item.id)
                    }
                })
            } else {
                this.optionClicked(data,item);
            }
        }
    }
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-context.scss';
    .list-group-horizontal {
        flex-direction: row;
        li{
            width: 150px;
        }
    }
</style>